import React from "react";
import { TwitterPicker } from 'react-color';
import { StyleTag } from "seed/helpers";


const ColorPicker = ({
  label,
  name,
  values,
  defaultColor,
  setFieldValue,
  onChange = () => { }
}) => {
  const colors = [
    "#FF5252", "#FF4081", "#7B1FA2", "#512DA8", "#536DFE", "#2065a5", "#3075BA", "#1976D2", "#03A9F4", "#0097A7", "#00796B", "#4CAF50", "#AFB42B",
    "#F57C00", "#FFA000", "#FF5722", "#5D4037", "#9E9E9E", "#455A64", "#212121", "default"
  ];
  return <div className="d-flex align-items-center w-100 mb-3">
    <StyleTag content={`
      .twitter-picker input[id^=rc-editable-input] {
        display: none;
      }
      .twitter-picker div[style*="rgb(240, 240, 240)"] {
        display: none !important;
      }
    `} />
    <div className="mb-1 mr-2" style={{ width: "100px" }}>
      {label}
    </div>
    <div style={{ position: "relative" }}>
      <div className="color-picker-preview" onClick={() => setFieldValue(`show_${name}`, !values[`show_${name}`])}>
        <div className="color" style={{ backgroundColor: values[name] ?? defaultColor }}></div>
      </div>
      <div style={{ position: "absolute", right: "110%", top: "-13px", zIndex: 1000 }}>
        {
          values[`show_${name}`] &&
          <TwitterPicker
            color={values[name] ?? defaultColor}
            width="240px"
            triangle="hide"
            onChange={(color) => {
              setFieldValue(name, color.hex);
              setFieldValue(`show_${name}`, false);
              onChange(color.hex);
            }}
            colors={colors}
          />
        }
      </div>
    </div>
  </div>
}

function getDarkerColor(color, v) {

	const normalize = (x) =>
		x > 255 ? x - (x - 255) : x;

	const getHex = (x) => {
		if (x < 0 || isNaN(x)) x = 0;
		if (x > 255) x = 255;
		x = x.toString(16);
		return x.length === 1 ? "0" + x : x;
	}

	if (color.length > 6)
		color = color.substring(1, color.length)

	var rgb = parseInt(color, 16);

	var r = Math.abs(((rgb >> 16) & 0xFF) + v);
	r = normalize(r);
	r = getHex(r);

	var g = Math.abs(((rgb >> 8) & 0xFF) + v);
	g = normalize(g);
	g = getHex(g);

	var b = Math.abs((rgb & 0xFF) + v);
	b = normalize(b);
	b = getHex(b);

	return "#" + r + g + b;

}


export { ColorPicker, getDarkerColor };